export default __webpack_public_path__ + "static/normalFont-3fcd755c17c89f48f2138cace0d6271c.woff2";